/* ==========================================================================
   MYSTERY SQUISHY — JS du thème (vanilla, ~sans dépendance, chargé en defer)
   ========================================================================== */
(() => {
  'use strict';
  const d = document;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const R = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const MS = window.MS || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* stockage indisponible : on ignore */ } }
  };

  /* ---------- Format monétaire ---------- */
  function money(cents) {
    const fmt = MS.moneyFormat || '{{amount_with_comma_separator}} €';
    const v = (Number(cents) || 0) / 100;
    const withComma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const plain = v.toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(v).toString())
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v).toString())
      .replace(/\{\{\s*amount\s*\}\}/, plain);
  }
  const priceLabel = (cents) => (Number(cents) > 0 ? money(cents) : (MS.strings && MS.strings.priceTbd) || '[PRIX À DÉFINIR]');

  /* ---------- Apparition au scroll + couleur de fond de page ---------- */
  function initReveal(root = d) {
    const els = $$('.ms-reveal, .ms-reveal-stagger, .ms-treasure', root);
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    els.forEach(e => io.observe(e));
  }
  function initPageColor() {
    const secs = $$('[data-page-bg]');
    if (!secs.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) d.body.style.setProperty('--page-bg', en.target.dataset.pageBg); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    secs.forEach(s => io.observe(s));
  }

  /* ---------- Vidéos : lecture auto sans son quand visibles ---------- */
  function initVideos(root = d) {
    const vids = $$('video[data-autoplay]', root);
    if (!vids.length) return;
    const play = v => { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => {
        const v = en.target;
        if (en.isIntersecting) { if (v.dataset.src && !v.src) { v.src = v.dataset.src; } if (!reduceMotion) play(v); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(v => io.observe(v));
    $$('[data-sound-toggle]', root).forEach(btn => btn.addEventListener('click', () => {
      const v = $(btn.dataset.soundToggle); if (!v) return;
      v.muted = !v.muted; if (v.paused) play(v);
      btn.setAttribute('aria-pressed', String(!v.muted));
      btn.querySelector('[data-label]').textContent = v.muted ? btn.dataset.on : btn.dataset.off;
    }));
  }

  /* ---------- Header ---------- */
  function initHeader() {
    const h = $('.ms-header'); if (!h) return;
    const onScroll = () => h.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Tiroirs (menu, panier) ---------- */
  let lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = d.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); d.body.classList.add('ms-lock');
    const f = el.querySelector('[data-autofocus], button, a, input'); if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.ms-drawer.is-open, .ms-modal.is-open, .ms-search.is-open')) d.body.classList.remove('ms-lock');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  function initDrawers() {
    d.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-open]');
      if (opener) {
        const target = $(opener.dataset.open);
        if (target) { e.preventDefault(); if (target.classList.contains('ms-search')) openSearch(); else openDrawer(target); }
        return;
      }
      const closer = e.target.closest('[data-close]');
      if (closer) { const box = closer.closest('.ms-drawer, .ms-modal, .ms-search'); if (box) { e.preventDefault(); if (box.classList.contains('ms-modal')) closeModal(box); else if (box.classList.contains('ms-search')) closeSearch(); else closeDrawer(box); } }
    });
    d.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const m = $('.ms-modal.is-open'); if (m) return closeModal(m);
      const s = $('.ms-search.is-open'); if (s) return closeSearch();
      const dr = $('.ms-drawer.is-open'); if (dr) closeDrawer(dr);
    });
  }

  /* ---------- Recherche prédictive ---------- */
  let searchTimer, searchCtrl;
  function openSearch() {
    const s = $('#ms-search'); if (!s) return;
    lastFocus = d.activeElement; s.classList.add('is-open'); d.body.classList.add('ms-lock');
    const i = $('input[type="search"]', s); if (i) setTimeout(() => i.focus(), 30);
  }
  function closeSearch() { const s = $('#ms-search'); if (!s) return; s.classList.remove('is-open'); if (!$('.ms-drawer.is-open, .ms-modal.is-open')) d.body.classList.remove('ms-lock'); if (lastFocus) lastFocus.focus(); }
  function initSearch() {
    const s = $('#ms-search'); if (!s) return;
    s.addEventListener('click', (e) => { if (e.target === s) closeSearch(); });
    const input = $('input[type="search"]', s); const out = $('[data-results]', s);
    if (!input || !out) return;
    input.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        if (searchCtrl) searchCtrl.abort();
        searchCtrl = new AbortController();
        try {
          const r = await fetch(`${R}search/suggest?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[limit]=6&resources[type]=product,collection,page`, { signal: searchCtrl.signal });
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const res = doc.querySelector('[data-predictive]');
          out.innerHTML = res ? res.innerHTML : '';
        } catch (err) { /* requête annulée */ }
      }, 220);
    });
  }

  /* ---------- Panier (AJAX + Section Rendering API) ---------- */
  const CART_SECTIONS = ['cart-drawer'];
  function renderCartSections(sections, opts = {}) {
    if (!sections) return;
    const html = sections['cart-drawer'];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-inner]');
      const cur = $('[data-cart-inner]');
      if (fresh && cur) cur.replaceWith(fresh);
      const count = fresh ? fresh.dataset.count : null;
      if (count !== null) updateCount(count, opts.bump);
      initReveal($('[data-cart-inner]'));
    }
  }
  function updateCount(n, bump) {
    $$('[data-cart-count]').forEach(el => { el.textContent = n; el.dataset.count = n; });
    if (bump && !reduceMotion) $$('[data-cart-icon]').forEach(el => { el.classList.remove('ms-cart-bump'); void el.offsetWidth; el.classList.add('ms-cart-bump'); });
  }
  async function addToCart(items, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    try {
      const r = await fetch(`${R}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: CART_SECTIONS, sections_url: window.location.pathname })
      });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
      renderCartSections(data.sections, { bump: true });
      const drawer = $('#ms-cart-drawer');
      const confirm = $('[data-cart-confirm]'); if (confirm) confirm.classList.add('is-visible');
      const lastId = data.items ? data.items[0].key : data.key;
      const line = lastId && $(`[data-line-key="${CSS.escape(lastId)}"]`); if (line) line.classList.add('is-new');
      if (btn && btn.classList.contains('ms-card__add')) { btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1400); }
      if (MS.cartType === 'drawer') openDrawer(drawer); else window.location.href = `${R}cart`;
    } catch (e) {
      alert(e.message || (MS.strings && MS.strings.cartError));
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    }
  }
  async function changeLine(key, quantity) {
    const inner = $('[data-cart-inner]'); if (inner) inner.style.opacity = '.6';
    try {
      const r = await fetch(`${R}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: CART_SECTIONS, sections_url: window.location.pathname })
      });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || data.message);
      renderCartSections(data.sections);
    } catch (e) { alert(e.message || (MS.strings && MS.strings.cartError)); }
    finally { const i = $('[data-cart-inner]'); if (i) i.style.opacity = ''; }
  }
  function initCart() {
    d.addEventListener('submit', (e) => {
      const form = e.target.closest('form[data-ajax-cart]');
      if (!form || MS.cartType !== 'drawer') return;
      e.preventDefault();
      const fd = new FormData(form);
      const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
      const props = {}; for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
      if (Object.keys(props).length) item.properties = props;
      addToCart([item], form.querySelector('[type="submit"]'));
    });
    d.addEventListener('click', (e) => {
      const q = e.target.closest('[data-line-qty]');
      if (q) { const key = q.dataset.key; const input = $(`input[data-key="${CSS.escape(key)}"]`); const cur = Number(input ? input.value : 1); changeLine(key, Math.max(0, cur + Number(q.dataset.lineQty))); return; }
      const rm = e.target.closest('[data-line-remove]');
      if (rm) { e.preventDefault(); changeLine(rm.dataset.lineRemove, 0); return; }
      const quick = e.target.closest('[data-quick-add]');
      if (quick) { e.preventDefault(); if (MS.cartType !== 'drawer') { window.location.href = quick.dataset.url; return; } addToCart([{ id: Number(quick.dataset.quickAdd), quantity: 1, ...(quick.dataset.xsell ? { properties: { _source: 'cross-sell' } } : {}) }], quick); }
    });
    d.addEventListener('change', (e) => {
      const input = e.target.closest('input[data-key]');
      if (input) changeLine(input.dataset.key, Math.max(0, Number(input.value)));
    });
  }

  /* ---------- Sélecteurs de quantité (fiche produit) ---------- */
  function initQty(root = d) {
    $$('[data-qty]', root).forEach(wrap => {
      const input = $('input', wrap);
      wrap.addEventListener('click', (e) => {
        const b = e.target.closest('button[data-step]'); if (!b) return;
        input.value = Math.max(1, Number(input.value || 1) + Number(b.dataset.step));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Fiche produit : variantes, prix, stock, galerie ---------- */
  function initProduct(root = d) {
    $$('[data-product]', root).forEach(pdp => {
      const dataEl = $('script[data-product-json]', pdp); if (!dataEl) return;
      const product = JSON.parse(dataEl.textContent);
      const form = $('form[data-ajax-cart]', pdp);
      const idInput = form ? $('input[name="id"]', form) : null;
      const priceEl = $('[data-price]', pdp);
      const stockEl = $('[data-stock]', pdp);
      const btn = form ? $('[type="submit"]', form) : null;
      const sticky = $('[data-sticky-buy]');

      const selected = () => $$('fieldset[data-option-index]', pdp).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
      const findVariant = (opts) => product.variants.find(v => v.options.every((o, i) => o === opts[i]));

      function markAvailability() {
        const cur = selected();
        $$('fieldset[data-option-index]', pdp).forEach(fs => {
          const idx = Number(fs.dataset.optionIndex);
          $$('input', fs).forEach(inp => {
            const test = cur.slice(); test[idx] = inp.value;
            const v = findVariant(test); inp.classList.toggle('is-unavailable', !v || !v.available);
          });
          const lab = $('[data-selected-value]', fs); const c = $('input:checked', fs); if (lab && c) lab.textContent = c.value;
        });
      }
      function update() {
        const v = findVariant(selected());
        markAvailability();
        if (!v) { if (btn) { btn.disabled = true; btn.querySelector('[data-btn-label]').textContent = MS.strings.unavailable; } return; }
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          const cmp = v.compare_at_price > v.price && v.price > 0;
          priceEl.innerHTML = `<span class="ms-price__current">${v.price > 0 ? money(v.price) : `<span class="ms-ph-price">${MS.strings.priceTbd}</span>`}</span>` +
            (cmp ? `<s class="ms-price__compare">${money(v.compare_at_price)}</s><span class="ms-price__save">-${Math.round((1 - v.price / v.compare_at_price) * 100)} %</span>` : '');
        }
        if (stockEl) {
          let cls = 'ms-stock', txt = MS.strings.inStock;
          if (!v.available) { cls += ' ms-stock--out'; txt = MS.strings.soldOut; }
          else if (v.low) { cls += ' ms-stock--low'; txt = MS.strings.lowStock; }
          stockEl.className = cls; stockEl.querySelector('[data-stock-label]').textContent = txt;
        }
        if (btn) {
          const noPrice = !(v.price > 0);
          btn.disabled = !v.available || noPrice;
          btn.querySelector('[data-btn-label]').textContent = !v.available ? MS.strings.soldOut : (noPrice ? MS.strings.comingSoon : MS.strings.addToCart);
          if (sticky) { const sb = $('button', sticky); if (sb) { sb.disabled = btn.disabled; sb.textContent = btn.querySelector('[data-btn-label]').textContent; } const sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = priceLabel(v.price); }
        }
        if (v.featured_media_id) {
          const slide = $(`[data-media-id="${v.featured_media_id}"]`, pdp);
          if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
        if (pdp.dataset.updateUrl === 'true') { const u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); }
      }
      pdp.addEventListener('change', (e) => { if (e.target.closest('fieldset[data-option-index]')) update(); });
      markAvailability();

      // Galerie : points, miniatures, zoom
      const track = $('[data-gallery-track]', pdp);
      if (track) {
        const slides = $$('.ms-gallery__slide', track);
        const dots = $$('[data-gallery-dot]', pdp), thumbs = $$('[data-gallery-thumb]', pdp);
        const setActive = (i) => { dots.concat(thumbs).forEach(b => b.setAttribute('aria-current', String(Number(b.dataset.index) === i))); };
        track.addEventListener('scroll', () => { const i = Math.round(track.scrollLeft / track.clientWidth); setActive(i); }, { passive: true });
        dots.concat(thumbs).forEach(b => b.addEventListener('click', () => { const s = slides[Number(b.dataset.index)]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); }));
        slides.filter(s => s.classList.contains('is-zoomable')).forEach(s => s.addEventListener('click', (e) => {
          const img = $('img', s); if (!img) return;
          const r = s.getBoundingClientRect();
          img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          s.classList.toggle('is-zoomed');
        }));
      }

      // Barre d'achat collante (mobile)
      if (sticky && btn && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => { const vis = !en.isIntersecting; sticky.classList.toggle('is-visible', vis); sticky.setAttribute('aria-hidden', String(!vis)); });
        io.observe(btn);
        const sb = $('button', sticky); if (sb) sb.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(btn); else btn.click(); });
      }
    });
  }

  /* ---------- Popup newsletter ---------- */
  function openModal(m) { lastFocus = d.activeElement; m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); d.body.classList.add('ms-lock'); const f = $('input[type="email"]', m) || $('button', m); if (f) setTimeout(() => f.focus({ preventScroll: true }), 60); }
  function closeModal(m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); if (!$('.ms-drawer.is-open, .ms-search.is-open')) d.body.classList.remove('ms-lock'); store.set('ms_popup_closed', String(Date.now())); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
  function initPopup() {
    const m = $('#ms-popup'); if (!m) return;
    if (m.dataset.success === 'true') { openModal(m); store.set('ms_subscribed', '1'); return; }
    if (d.body.dataset.template && /^(cart|customers)/.test(d.body.dataset.template)) return;
    if (store.get('ms_subscribed')) return;
    const closed = Number(store.get('ms_popup_closed') || 0);
    const days = Number(m.dataset.frequencyDays || 7);
    if (closed && Date.now() - closed < days * 864e5) return;
    const delay = Number(m.dataset.delay || 3) * 1000;
    setTimeout(() => { if (!$('.ms-drawer.is-open')) openModal(m); }, delay);
    m.addEventListener('click', (e) => { if (e.target.classList.contains('ms-modal__overlay')) closeModal(m); });
    const form = $('form', m); if (form) form.addEventListener('submit', () => store.set('ms_subscribed', '1'));
  }

  /* ---------- Copier le code promo ---------- */
  function initCopy() {
    d.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-copy]'); if (!b) return;
      try { await navigator.clipboard.writeText(b.dataset.copy); const t = b.textContent; b.textContent = MS.strings.copied; setTimeout(() => { b.textContent = t; }, 1500); } catch (err) { /* presse-papiers indisponible */ }
    });
  }

  /* ---------- Mystery Box : secousse au clic ---------- */
  function initMysteryBox() {
    d.addEventListener('click', (e) => {
      const b = e.target.closest('.ms-mbox[data-shake]'); if (!b || reduceMotion) return;
      b.classList.remove('is-shaking'); void b.offsetWidth; b.classList.add('is-shaking');
    });
  }

  /* ---------- Démarrage ---------- */
  d.documentElement.classList.add('js');
  const boot = () => {
    initHeader(); initDrawers(); initSearch(); initCart(); initQty(); initProduct();
    initReveal(); initPageColor(); initVideos(); initPopup(); initCopy(); initMysteryBox();
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();

  // Compatibilité éditeur de thème Shopify
  d.addEventListener('shopify:section:load', (e) => { initReveal(e.target); initVideos(e.target); initQty(e.target); initProduct(e.target); });
  d.addEventListener('shopify:section:select', (e) => { if (e.target.querySelector('#ms-popup')) openModal($('#ms-popup')); });
  d.addEventListener('shopify:section:deselect', (e) => { const m = e.target.querySelector('#ms-popup.is-open'); if (m) closeModal(m); });

  window.MSTheme = { addToCart, openDrawer, closeDrawer, money };
})();
